export enum ProvenancesActions {
  RequestForProvenances = 'Request data for provenances',
  ProvenancesAreAccepted = 'Provenances came from API and they\'re stored in store',
  ProvenancesAreRejected = 'Cannot fetch provenances from API',
  ToggleProvenancesModal = 'Toggle modal - provenances',
  RequestAddProvenance = 'Request add procenance',
  AcceptedProvenance = 'Provenance was accepted',
  ProvenanceAreRejected = 'Provenance was rejected',
  RequestDeleteProvenance = 'Request delete provenance',
  DeletedProvenance = 'Provenance was deleted',
  ProvenanceDeleteAreRejected = 'Provenance delete request was rejected',
}
